import OrgUnitAdminUserViews from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';

import NavLinks from '../../views/meet/NavLinks';

const INITIAL_STATE = [
  {
    name: OrgUnitAdminUserViews.OME_MEET_INFO_TEAM_ENTRY,
    displayName: 'Meet Info',
    path: NavLinks.OU_ADMIN_MEET_INFO,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: true
  },
  {
    name: OrgUnitAdminUserViews.OME_MEET_ROSTER_ENTRIES,
    displayName: 'Roster Entries',
    path: NavLinks.OU_ADMIN_ROSTER_ENTRIES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: OrgUnitAdminUserViews.OME_MEET_RELAY_ENTRIES,
    displayName: 'Relay Entries',
    path: NavLinks.OU_ADMIN_RELAY_ENTRIES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: OrgUnitAdminUserViews.OME_MEET_CREDENTIALS,
    displayName: 'Credentials',
    path: NavLinks.OU_ADMIN_CREDENTIALS,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: OrgUnitAdminUserViews.OME_MEET_ENTRY_REPORTS,
    displayName: 'Entry Reports',
    path: NavLinks.OU_ADMIN_REPORTING,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: OrgUnitAdminUserViews.OME_MEET_SUBMIT,
    displayName: 'Submit',
    path: NavLinks.OU_ADMIN_PURCHASES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  }];

const GetInitialStateMeetRoute = (viewName) => {
  const state = INITIAL_STATE.find(x => x.name === viewName);
  return JSON.parse(JSON.stringify(state || {}));
};

export default GetInitialStateMeetRoute;